import React from "react";
import Icon from "../Icon";

// This banner is used on the ListGrid template
const ListGridBanner = ({ page }) => {
  const colorKey = page.title.split(" ")[0].toLowerCase();

  return (
    <div
      className={`banner--list-grid bg-${colorKey} relative flex flex-column items-center justify-center-l items-start-l`}
    >
      <h1 className="banner--list-grid__headline white tc tl-l h-2 h-1--l mb1 mb2-l">
        {page.title}
      </h1>
      <h2 className="banner--list-grid__subtitle white ttu tc tl-l h-5 mb0">
        {page.subtitle}
      </h2>
      <Icon className="banner--list-grid__illo" path={`illi-${colorKey}`} />
      {/* <Icon
        path="downtown-explore"
        className="banner--list-grid__illo absolute-l w-40-l mt1 mt0-l top-0 right-0"
      /> */}
    </div>
  );
};

export default ListGridBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/ListGridBanner.js